import React from "react";

import "./horizontal-stacked-chart.css";
import { reduceString } from "../../../utils/reduceString";
import { Tooltippy } from "../../../actions/Tippy";

export default function HorizontalStackedChart({
  data = {
    good: 97,
    bad: 3,
    total: 100,
    goodPercent: 97,
    badPercent: 3,
  },
  keys = ["Bom", "Ruim"],
  title = "Atendimento",
  subtitle = "Subqualificadores de atendimento",
  subqualifiers = [
    {
      value: 10,
      label: "O atendimento foi demorado",
      id: 1,
    },
    {
      value: 10,
      label: "O funcionário não me tratou bem",
      id: 2,
    },
    {
      value: 10,
      label: "Me deram informações erradas",
      id: 3,
    },
    {
      value: 10,
      label: "O desjejum não estava bom",
      id: 4,
    },
    {
      value: 10,
      label: "O prazo dos resultados não foi bom",
      id: 5,
    },
  ],
  isTooltippyActive = false,
  isScrollActive = false,
}) {
  const hasSubqualifiers = !!subqualifiers && subqualifiers.length > 0;

  return (
    <div
      className={
        isScrollActive
          ? "horizontal-stacked-chart horizontal-stacked-chart--scroll-active"
          : "horizontal-stacked-chart"
      }
    >
      <div className="horizontal-stacked-chart__first-line">
        {isTooltippyActive ? (
          <Tooltippy content={title ? title : ""}>
            <span className="horizontal-stacked-chart__first-line__title">
              {reduceString(title, 55)}
            </span>
          </Tooltippy>
        ) : (
          <span className="horizontal-stacked-chart__first-line__title">
            {title}
          </span>
        )}
        <div className="horizontal-stacked-chart__first-line__bar">
          <div
            className="horizontal-stacked-chart__first-line__bar__green"
            style={{ flex: data.goodPercent }}
          >
            <span className="horizontal-stacked-chart__first-line__bar__green__value">
              {data.goodPercent >= 20
                ? `${data.goodPercent.toFixed(2)}%`
                : null}
            </span>
          </div>
          <div
            className="horizontal-stacked-chart__first-line__bar__red"
            style={{ flex: data.badPercent }}
          >
            <span className="horizontal-stacked-chart__first-line__bar__red__value">
              {data.badPercent >= 20 ? `${data.badPercent.toFixed(2)}%` : null}
            </span>
          </div>
        </div>
        <div className="horizontal-stacked-chart__first-line__legend">
          <div className="horizontal-stacked-chart__first-line__legend__indicator">
            <div className="horizontal-stacked-chart__first-line__legend__indicator__green-circle"></div>
            <span className="horizontal-stacked-chart__first-line__legend__indicator__value">{`Bom (${data.good})`}</span>
          </div>

          <div className="horizontal-stacked-chart__first-line__legend__indicator">
            <div className="horizontal-stacked-chart__first-line__legend__indicator__red-circle"></div>
            <span className="horizontal-stacked-chart__first-line__legend__indicator__value">{`Ruim (${data.bad})`}</span>
          </div>
        </div>
      </div>
      {hasSubqualifiers && (
        <div className="horizontal-stacked-chart__second-line">
          <span className="horizontal-stacked-chart__second-line__subtitle">
            {subtitle}
          </span>
          <ul
            className={`${
              isScrollActive
                ? "horizontal-stacked-chart__second-line__second-line-holder--active-scroll"
                : ""
            }`}
          >
            {subqualifiers.map((subqualifier, index) => {
              return (
                <li
                  key={index}
                  className="horizontal-stacked-chart__second-line__subqualifier"
                >
                  <div className="horizontal-stacked-chart__second-line__subqualifier__value">
                    {subqualifier.value}
                  </div>
                  <div className="horizontal-stacked-chart__second-line__subqualifier__label">
                    {subqualifier.label}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
